import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'
import Dashboard from '@/views/home/dashboard/Dashboard'
import ResetPassword from '@/views/activation/Reset'
import ActivateUser from '@/views/activation/Activation'
import DownloadDocument from '@/views/download-document/DownloadDocument'
import Login from '@/views/login/LoginMulti'
import LoginInitial from '@/views/login/initial-login/LoginInitial'
import Registration from '@/views/registration/Registration'
import LoginForgottenPassword from '@/views/login/forgotten-password/LoginForgottenPassword'
import Home from '@/views/home/Home'
import Administration from '@/views/home/administration/Administration'
import Registry from '@/views/home/registry/Registry'
import Reporting from '@/views/home/reporting/Reporting'
import RegistryOrganizations from '@/views/home/registry/organization/RegistryOrganization'
import RegistryOrganizationInformation from '@/views/home/registry/organization/organization-information/RegistryOrganizationInformation'
import UserProfile from '@/views/home/administration/user-profile/UserProfile'
import UserManagement from '@/views/home/administration/user-management/UserManagement'
import UserInformation from '@/views/home/administration/user-management/user-information/UserInformation'
import UserCreate from '@/views/home/administration/user-create/UserCreate'
import RoleManagement from '@/views/home/administration/role-management/RoleManagement'
import RoleInformation from '@/views/home/administration/role-management/role-information/RoleInformation'
import RoleCreate from '@/views/home/administration/role-create/RoleCreate'
import OrganizationManagement from '@/views/home/administration/organization-management/OrganizationManagement'
import OrganizationInformation from '@/views/home/administration/organization-management/organization-information/OrganizationInformation'
import ProjectListManagement from '@/views/home/projects/list/ProjectListManagement'
import ProjectListType from '@/views/home/projects/list/types/ProjectListType'
import ProjectManagement from '@/views/home/projects/project-management/ProjectManagement'
import ProjectManagementArchive from '@/views/home/projects/project-management/ProjectManagementArchive'
import ProjectCreate from '@/views/home/projects/project-create/ProjectCreate'
import ProjectInformation from '@/views/home/projects/project-management/project-information/ProjectInformation'
import ProjectInformationArchived from '@/views/home/projects/project-management/project-information/ProjectInformationArchived'
import ProjectDetails from '@/views/home/projects/project-management/project-information/details/ProjectDetails'
import ProjectPhases from '@/views/home/projects/project-management/project-information/phases/ProjectPhases'
import PhaseForms from '@/views/home/projects/project-management/project-information/phases/forms/PhaseForms'
import PhaseActivities from '@/views/home/projects/project-management/project-information/phases/activities/PhaseActivities'
import SuccessKeyIndicator from '@/views/home/projects/project-management/project-information/phases/success-key-indicators/SuccessKeyIndicators'
import ProjectDocuments from '@/views/home/projects/project-management/project-information/documents/ProjectDocuments'
import ProjectDocumentRevisions from '@/views/home/projects/project-management/project-information/documents/revisions/ProjectDocumentRevisions'
import ProjectOptions from '@/views/home/projects/project-management/project-information/options/ProjectOptions'
import ProjectOrganizations from '@/views/home/projects/project-management/project-information/options/organizations/ProjectOrganizations'
import ProjectAppropriations from '@/views/home/projects/project-management/project-information/options/appropriations/ProjectAppropriations'
import ProjectSettings from '@/views/home/projects/project-management/project-information/options/settings/ProjectSettings'
import PIF150 from '@/views/home/projects/project-management/project-forms/PIF1-5-0/PIF1-5-0'
import PIF151 from '@/views/home/projects/project-management/project-forms/PIF1-5-1/PIF1-5-1'
import PIF152 from '@/views/home/projects/project-management/project-forms/PIF1-5-2/PIF1-5-2'
import PIF153 from '@/views/home/projects/project-management/project-forms/PIF1-5-3/PIF1-5-3'
import PIF154 from '@/views/home/projects/project-management/project-forms/PIF1-5-4/PIF1-5-4'
import PIF155 from '@/views/home/projects/project-management/project-forms/PIF1-5-5/PIF1-5-5'
import PifMini from '@/views/home/projects/project-management/project-forms/pif-mini/PifMini'
import Idea from '@/views/home/projects/project-management/project-forms/idea/Idea'
import Important from '@/views/home/projects/project-management/project-forms/important/Important'
import Preparedness from '@/views/home/projects/project-management/project-forms/preparedness/Preparedness'
import ProjectIdentification from '@/views/home/projects/project-management/project-forms/projectidentification/ProjectIdentification'
import PreImplementation from '@/views/home/projects/project-management/project-forms/preimplementation/PreImplementation'
import Plan from '@/views/home/projects/project-management/project-forms/plan/Plan'
import Correction from '@/views/home/projects/project-management/project-forms/correction/Correction'
import Quarterly from '@/views/home/projects/project-management/project-forms/quarterly/Quarterly'
import QuarterlyCorrection from '@/views/home/projects/project-management/project-forms/quarterlycorrection/QuarterlyCorrection'
import Conclusion from '@/views/home/projects/project-management/project-forms/conclusion/Conclusion'
import Effects from '@/views/home/projects/project-management/project-forms/effects/Effects'
import Rationalization from '@/views/home/projects/project-management/project-forms/rationalization/Rationalization'
import i18n from '@/i18n'
import { accessTokenValid, refreshTokenValid, refreshToken } from './auth'
import securityStore from '../store/security-store'

const $t = i18n.messages[i18n.locale]

Vue.use(Router)
Vue.use(VueResource)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      name: 'registration',
      path: '/register-organization',
      component: Registration,
      meta: {
        title: $t.registration.title
      }
    },
    {
      name: 'activation',
      path: '/activation',
      component: ActivateUser,
      meta: {
        title: $t.login.activate
      }
    },
    {
      name: 'reset',
      path: '/reset-password',
      component: ResetPassword,
      meta: {
        title: $t.login.reset
      }
    },
    {
      name: 'download',
      path: '/document-download',
      component: DownloadDocument,
      meta: {
        title: $t.documents.download
      }
    },
    {
      name: 'login-multi',
      path: '/login',
      component: Login,
      meta: {
        title: $t.login.title
      }
    },
    {
      name: 'login-initial',
      path: '/login/initial',
      component: LoginInitial,
      meta: {
        title: $t.login.title
      }
    },
    {
      name: 'forgotten-password',
      path: '/login/password-reset',
      component: LoginForgottenPassword,
      meta: {
        title: $t.login.forgottenPassword
      }
    },
    {
      path: '',
      component: Home,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: {
            title: $t.sidebar.dashboard
          }
        },
        {
          path: 'administration/',
          component: Administration,
          name: 'administration',
          meta: {
            title: $t.sidebar.administration
          }
        },
        {
          path: 'administration/user/management',
          component: UserManagement,
          name: 'userManagement',
          meta: {
            title: $t.sidebar.viewUsers
          }
        },
        {
          path: 'administration/user/profile',
          component: UserProfile,
          name: 'userProfile',
          meta: {
            title: $t.sidebar.viewUserProfile
          }
        },
        {
          path: 'administration/user/create',
          component: UserCreate,
          name: 'userCreate',
          meta: {
            title: $t.sidebar.createUser
          }
        },
        {
          path: 'administration/user/:login',
          component: UserInformation,
          name: 'userAdministration',
          meta: {
            title: $t.sidebar.viewUserDetails
          }
        },
        {
          path: 'administration/role/management',
          component: RoleManagement,
          name: 'roleManagement',
          meta: {
            title: $t.sidebar.viewRoles
          }
        },
        {
          path: 'administration/role/create',
          component: RoleCreate,
          name: 'roleCreate',
          meta: {
            title: $t.sidebar.createRole
          }
        },
        {
          path: 'administration/role/:roleId',
          component: RoleInformation,
          name: 'roleAdministration',
          meta: {
            title: $t.sidebar.viewRoleDetails
          }
        },
        {
          path: 'administration/organization/management',
          component: OrganizationManagement,
          name: 'organizationManagement',
          meta: {
            title: $t.sidebar.viewOrganizations
          }
        },
        {
          path: 'administration/organization/:organizationId',
          component: OrganizationInformation,
          name: 'organizationAdministration',
          meta: {
            title: $t.sidebar.viewOrganizationDetails
          }
        },
        {
          path: 'reporting/',
          component: Reporting,
          name: 'reporting',
          meta: {
            title: $t.sidebar.reports
          }
        },
        {
          path: 'registry/',
          component: Registry,
          name: 'registry',
          meta: {
            title: $t.sidebar.registries
          }
        },
        {
          path: 'registry/organizations',
          name: 'registryOrganizations',
          component: RegistryOrganizations,
          meta: {
            title: $t.sidebar.registryOrganizations
          }
        },
        {
          path: 'registry/organization/:organizationId',
          name: 'registryOrganizationInformation',
          component: RegistryOrganizationInformation,
          meta: {
            title: $t.sidebar.registryOrganizations
          }
        },
        {
          path: 'project-lists/',
          component: ProjectListManagement,
          name: 'projectListsManagement',
          meta: {
            title: $t.sidebar.viewProjectLists
          },
          children: [
            {
              path: ':listType',
              name: 'projectListsType',
              component: ProjectListType,
              meta: {
                title: $t.sidebar.viewProjectLists
              }
            },
            {
              path: ':listType/:listName',
              name: 'projectListsType',
              component: ProjectListType,
              meta: {
                title: $t.sidebar.viewProjectListDetails
              }
            }
          ]
        },
        {
          path: 'archived-projects/',
          component: ProjectManagementArchive,
          name: 'projectManagementArchive',
          meta: {
            title: $t.sidebar.viewProjects
          }
        },
        {
          path: 'projects/',
          component: ProjectManagement,
          name: 'projectManagement',
          meta: {
            title: $t.sidebar.viewProjects
          }
        },
        {
          path: 'projects/create',
          component: ProjectCreate,
          name: 'projectCreate',
          meta: {
            title: $t.sidebar.createProject
          }
        },
        {
          path: 'projects/:projectCode',
          component: ProjectInformation,
          name: 'singleProject',
          children: [
            {
              path: 'details',
              name: 'singleProjectdetails',
              component: ProjectDetails,
              meta: {
                title: $t.sidebar.projectDetails
              }
            },
            {
              path: 'options',
              name: 'singleProjectoptions',
              component: ProjectOptions,
              meta: {
                title: $t.sidebar.projectDetails
              },
              children: [
                {
                  path: 'organizations',
                  name: 'singleProjectoptionsorganizations',
                  component: ProjectOrganizations,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                },
                {
                  path: 'appropriations',
                  name: 'singleProjectoptionsappropriations',
                  component: ProjectAppropriations,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                },
                {
                  path: 'settings',
                  name: 'singleProjectoptionssettings',
                  component: ProjectSettings,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                }
              ]
            },
            {
              path: 'documents',
              name: 'singleProjectdocuments',
              component: ProjectDocuments,
              meta: {
                title: $t.sidebar.projectDetails
              }
            },
            {
              path: 'documents/:documentId/revisions',
              name: 'singleProjectdocumentsrevisions',
              component: ProjectDocumentRevisions,
              meta: {
                title: $t.sidebar.projectDetails
              }
            },
            {
              path: 'documents/:documentId/revisions/:revisionId',
              name: 'singleProjectdocumentsrevisions',
              component: ProjectDocumentRevisions,
              meta: {
                title: $t.sidebar.projectDetails
              }
            },
            {
              path: 'phases',
              name: 'singleProjectphases',
              component: ProjectPhases,
              meta: {
                title: $t.sidebar.projectDetails
              }
            },
            {
              path: 'phases/:projectPhaseId',
              name: 'singleProjectPhases',
              component: ProjectPhases,
              meta: {
                title: $t.sidebar.projectDetails
              },
              children: [
                {
                  path: 'forms',
                  name: 'singleProjectphasesforms',
                  component: PhaseForms,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                },
                {
                  path: 'activities',
                  name: 'singleProjectphasesactivities',
                  component: PhaseActivities,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                },
                {
                  path: 'successKeyIndicators',
                  name: 'singleProjectphasessuccessKeyIndicator',
                  component: SuccessKeyIndicator,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                }
              ]
            }

          ]
        },
        {
          path: 'projects-archived/:projectCode',
          component: ProjectInformationArchived,
          name: 'singleProject',
          children: [
            {
              path: 'details',
              name: 'singleProjectdetails',
              component: ProjectDetails,
              meta: {
                title: $t.sidebar.projectDetails
              }
            },
            {
              path: 'options',
              name: 'singleProjectoptions',
              component: ProjectOptions,
              meta: {
                title: $t.sidebar.projectDetails
              },
              children: [
                {
                  path: 'organizations',
                  name: 'singleProjectoptionsorganizations',
                  component: ProjectOrganizations,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                },
                {
                  path: 'appropriations',
                  name: 'singleProjectoptionsappropriations',
                  component: ProjectAppropriations,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                },
                {
                  path: 'settings',
                  name: 'singleProjectoptionssettings',
                  component: ProjectSettings,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                }
              ]
            },
            {
              path: 'documents',
              name: 'singleProjectdocuments',
              component: ProjectDocuments,
              meta: {
                title: $t.sidebar.projectDetails
              }
            },
            {
              path: 'documents/:documentId/revisions',
              name: 'singleProjectdocumentsrevisions',
              component: ProjectDocumentRevisions,
              meta: {
                title: $t.sidebar.projectDetails
              }
            },
            {
              path: 'documents/:documentId/revisions/:revisionId',
              name: 'singleProjectdocumentsrevisions',
              component: ProjectDocumentRevisions,
              meta: {
                title: $t.sidebar.projectDetails
              }
            },
            {
              path: 'phases',
              name: 'singleProjectphases',
              component: ProjectPhases,
              meta: {
                title: $t.sidebar.projectDetails
              }
            },
            {
              path: 'phases/:projectPhaseId',
              name: 'singleProjectPhases',
              component: ProjectPhases,
              meta: {
                title: $t.sidebar.projectDetails
              },
              children: [
                {
                  path: 'forms',
                  name: 'singleProjectphasesforms',
                  component: PhaseForms,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                },
                {
                  path: 'activities',
                  name: 'singleProjectphasesactivities',
                  component: PhaseActivities,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                },
                {
                  path: 'successKeyIndicators',
                  name: 'singleProjectphasessuccessKeyIndicator',
                  component: SuccessKeyIndicator,
                  meta: {
                    title: $t.sidebar.projectDetails
                  }
                }
              ]
            }

          ]
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/1-5-0/id/:phaseFormId',
          component: PIF150,
          name: 'PIF150'
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/1-5-1/id/:phaseFormId',
          component: PIF151,
          name: 'PIF151'
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/1-5-2/id/:phaseFormId',
          component: PIF152,
          name: 'PIF152'
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/1-5-3/id/:phaseFormId',
          component: PIF153,
          name: 'PIF153'
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/1-5-4/id/:phaseFormId',
          component: PIF154,
          name: 'PIF154'
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/1-5-5/id/:phaseFormId',
          component: PIF155,
          name: 'PIF155'
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/pif-mini/id/:phaseFormId',
          component: PifMini,
          name: 'pifmini',
          meta: {
            title: $t.sidebar.formPifMini
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/ideja/id/:phaseFormId',
          component: Idea,
          name: 'idea',
          meta: {
            title: $t.sidebar.formIdea
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/ideja/id/:phaseFormId/revision/:revision',
          component: Idea,
          name: 'idea',
          meta: {
            title: $t.sidebar.formIdea
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/posebnog-znacaja/id/:phaseFormId',
          component: Important,
          name: 'important',
          meta: {
            title: $t.sidebar.formImportant
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/posebnog-znacaja/id/:phaseFormId/revision/:revision',
          component: Important,
          name: 'important',
          meta: {
            title: $t.sidebar.formImportant
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/spremnost/id/:phaseFormId',
          component: Preparedness,
          name: 'preparedness',
          meta: {
            title: $t.sidebar.formPreparedness
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/spremnost/id/:phaseFormId/revision/:revision',
          component: Preparedness,
          name: 'preparedness',
          meta: {
            title: $t.sidebar.formPreparedness
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/identifikacija-projekta/id/:phaseFormId',
          component: ProjectIdentification,
          name: 'projectidentification',
          meta: {
            title: $t.sidebar.formProjectIdentification
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/identifikacija-projekta/id/:phaseFormId/revision/:revision',
          component: ProjectIdentification,
          name: 'projectidentification',
          meta: {
            title: $t.sidebar.formProjectIdentification
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/predimplementacija/id/:phaseFormId',
          component: PreImplementation,
          name: 'preimplementation',
          meta: {
            title: $t.sidebar.formPreImplementation
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/predimplementacija/id/:phaseFormId/revision/:revision',
          component: PreImplementation,
          name: 'preimplementation',
          meta: {
            title: $t.sidebar.formPreImplementation
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/plan/id/:phaseFormId',
          component: Plan,
          name: 'plan',
          meta: {
            title: $t.sidebar.formPlan
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/korekcija/id/:phaseFormId',
          component: Correction,
          name: 'correction',
          meta: {
            title: $t.sidebar.formCorrection
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/plan/id/:phaseFormId/revision/:revision',
          component: Plan,
          name: 'plan',
          meta: {
            title: $t.sidebar.formPlan
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/korekcija/id/:phaseFormId/revision/:revision',
          component: Correction,
          name: 'correction',
          meta: {
            title: $t.sidebar.formCorrection
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/kvartalni/id/:phaseFormId',
          component: Quarterly,
          name: 'quarterly',
          meta: {
            title: $t.sidebar.formQuarterly
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/kvartalni-korekcija/id/:phaseFormId',
          component: QuarterlyCorrection,
          name: 'quarterlycorrection',
          meta: {
            title: $t.sidebar.formQuarterlyCorrection
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/kvartalni/id/:phaseFormId/revision/:revision',
          component: Quarterly,
          name: 'quarterly',
          meta: {
            title: $t.sidebar.formQuarterly
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/racionalizacija/id/:phaseFormId',
          component: Rationalization,
          name: 'rationalization',
          meta: {
            title: $t.sidebar.formRationalization
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/racionalizacija/id/:phaseFormId/revision/:revision',
          component: Rationalization,
          name: 'rationalization',
          meta: {
            title: $t.sidebar.formRationalization
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/zavrsni/id/:phaseFormId',
          component: Conclusion,
          name: 'conclusion',
          meta: {
            title: $t.sidebar.formConclusion
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/zavrsni/id/:phaseFormId/revision/:revision',
          component: Conclusion,
          name: 'conclusion',
          meta: {
            title: $t.sidebar.formConclusion
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/efekti/id/:phaseFormId',
          component: Effects,
          name: 'effects',
          meta: {
            title: $t.sidebar.formEffects
          }
        },
        {
          path: 'projects/:projectCode/phases/:projectPhaseId/forms/efekti/id/:phaseFormId/revision/:revision',
          component: Effects,
          name: 'effects',
          meta: {
            title: $t.sidebar.formEffects
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // EventBus.$emit('page-change')
  // Site title
  const siteName = $t.title
  let pageName

  if (to.name === 'start-page') {
    pageName = siteName
  } else {
    pageName = to.meta.title ? to.meta.title + ' - ' + siteName : siteName
  }

  if (to.name === 'download' && from.name === 'singleProjectdocumentsrevisions') {
    window.history.back()
  }

  document.title = pageName

  // if (!to.matched.length) {
  //   next('/not-found')
  // }
  const isProductionEnvironment = process.env.NODE_ENV.toUpperCase() === 'production'.toUpperCase()
  // Authorization
  if (!isProductionEnvironment) {
    console.log('Executing authorization guard for ' + to.path)
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!accessTokenValid()) {
      if (!refreshTokenValid()) {
        if (!isProductionEnvironment) {
          console.log('Tokens expired - routing not authorized')
        }
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        })
      } else {
        if (!isProductionEnvironment) {
          console.log('Refreshing access token')
        }
        refreshToken(to, from, next)
      }
    } else {
      if (!isProductionEnvironment) {
        console.log('Routing authorized for ' + to.path)
      }
      next()
    }
  } else {
    if (!isProductionEnvironment) {
      console.log('No authorization required for ' + to.path)
    }
    next() // make sure to always call next()!
  }
})

router.afterEach((to, from, next) => {
  securityStore.dispatch('startSessionInterval')
})

export default router
